<template>
    <div class="relative h-72 overflow-hidden">
        <transition :name="transitionClass">
            <div
                class="absolute w-full h-72 top-0 inset-x-0 flex justify-center"
                :key="page"
            >
                <img :src="currentPhoto" />
            </div>
        </transition>

        <div class="absolute left-6 inset-y-0 flex items-center">
            <div :class="buttonClasses" @click="previousPage">
                <span class="icon-np-arrow-back"></span>
            </div>
        </div>

        <div class="absolute right-6 inset-y-0 flex items-center">
            <div :class="buttonClasses" @click="nextPage">
                <span class="icon-np-arrow-forward"></span>
            </div>
        </div>
    </div>
</template>

<style scoped>
.slide-from-right-leave-active,
.slide-from-right-enter-active,
.slide-from-left-leave-active,
.slide-from-left-enter-active {
    transition: 0.8s;
}
.slide-from-right-enter-from,
.slide-from-left-leave-to {
    transform: translate(100%, 0);
}
.slide-from-right-leave-to,
.slide-from-left-enter-from {
    transform: translate(-100%, 0);
}
</style>

<script>
export default {
    props: {
        photos: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            page: 0,
            transitionClass: "slide-from-right",
            buttonClasses: [
                "w-7",
                "h-7",
                "rounded-full",
                "flex",
                "items-center",
                "justify-center",
                "text-white",
                "bg-primary",
            ],
        };
    },
    computed: {
        currentPhoto() {
            return this.photos[this.page];
        },
    },
    methods: {
        nextPage() {
            this.transitionClass = "slide-from-right";
            if (this.page + 1 < this.photos.length) {
                this.page++;
            } else {
                this.page = 0;
            }
        },
        previousPage() {
            this.transitionClass = "slide-from-left";
            if (this.page > 0) {
                this.page--;
            } else {
                this.page = this.photos.length - 1;
            }
        },
    },
};
</script>
